;(function () {
  const sliderInstances = new WeakMap()

  function toNumber(value, fallback) {
    const number = parseFloat(value)
    return Number.isNaN(number) ? fallback : number
  }

  function toInteger(value, fallback) {
    const number = parseInt(value, 10)
    return Number.isNaN(number) ? fallback : number
  }

  function getBreakpoints(element, perPage, paddingLeft, paddingRight) {
    if (element.dataset.breakpoints) {
      try {
        return JSON.parse(element.dataset.breakpoints)
      } catch (error) {
        console.warn('Invalid breakpoints JSON', element.dataset.breakpoints)
      }
    }

    const br1440 = toInteger(element.dataset['1440br'], perPage)
    const br1199 = toInteger(element.dataset['1199br'], perPage)
    const br989 = toInteger(element.dataset['989br'], perPage)
    const br767 = toInteger(element.dataset['767br'], 1)
    const br576 = toInteger(element.dataset['576br'], 1)

    return {
      1440: {
        perPage: br1440,
        padding: {
          left: paddingLeft + 'px',
          right: paddingRight + 'px',
        },
      },
      1199: {
        perPage: br1199,
        padding: {
          left: paddingLeft / 1.5 + 'px',
          right: paddingRight / 1.5 + 'px',
        },
      },
      989: {
        perPage: br989,
        padding: {
          left: paddingLeft / 2 + 'px',
          right: paddingRight / 2 + 'px',
        },
      },
      767: {
        perPage: br767,
        padding: {
          left: paddingLeft / 3 + 'px',
          right: paddingRight / 3 + 'px',
        },
      },
      576: {
        perPage: br576,
        padding: {
          left: '0px',
          right: '0px',
        },
      },
    }
  }

  function getSplideOptions(element) {
    const isMarquee = element.classList.contains('marquee-row')
    const perPage = toInteger(element.dataset.perPage, 1)
    const perMove = toInteger(element.dataset.perMove, 1)
    const paddingLeft = element.dataset.paddingLeft ? toInteger(element.dataset.paddingLeft, 0) : 0
    const paddingRight = element.dataset.paddingRight ? toInteger(element.dataset.paddingRight, 0) : 0
    const speed = toNumber(element.dataset.speed, 600)
    const autoWidth = element.dataset.autoWidth === 'true'
    // const fixedWidth = element.dataset.fixedWidth
    const pauseOnHover = element.dataset.pauseOnHover !== 'false'
    const pauseOnFocus = element.dataset.pauseOnFocus !== 'false'

    const options = {
      type: element.dataset.type || 'slide',
      arrows: element.dataset.arrows === 'true',
      pagination: element.dataset.pagination === 'true',
      perPage: perPage,
      perMove: perMove,
      drag: isMarquee ? false : element.dataset.drag === 'true',
      autoplay: isMarquee ? false : element.dataset.autoplay === 'true',
      gap: element.dataset.gap || '0px',
      interval: toInteger(element.dataset.autoplayintervel, 5000),
      speed: isMarquee ? 0 : speed,
      easing: element.dataset.easing || 'ease',
      direction: element.dataset.direction || 'ltr',
      pauseOnHover: pauseOnHover,
      pauseOnFocus: pauseOnFocus,
      rewind: false,
      autoWidth: autoWidth,
      padding: {
        left: paddingLeft,
        right: paddingRight,
      },
      breakpoints: getBreakpoints(element, perPage, paddingLeft, paddingRight),
    }

    // if (!autoWidth && fixedWidth) {
    //   options.fixedWidth = fixedWidth
    // }

    if (isMarquee) {
      options.clones = 30
      options.autoScroll = {
        speed: speed,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: false,
      }
    }

    return options
  }

  function mountSplide(element) {
    if (!element || sliderInstances.has(element) || element.classList.contains('is-initialized')) return
    if (typeof Splide === 'undefined') return

    const isMarquee = element.classList.contains('marquee-row')
    const splide = new Splide(element, getSplideOptions(element))
    let progressInterval

    const prevBtn = element.querySelector('.splide-custom-prev')
    const nextBtn = element.querySelector('.splide-custom-next')

    const goPrev = event => {
      event.preventDefault()
      splide.go('<')
    }

    const goNext = event => {
      event.preventDefault()
      splide.go('>')
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev)
    if (nextBtn) nextBtn.addEventListener('click', goNext)

    function updateArrows() {
      if (!splide.Components.Controller) return

      const endIndex = splide.Components.Controller.getEnd()

      if (prevBtn) {
        prevBtn.classList.toggle('is-disabled', splide.index === 0)
      }

      if (nextBtn) {
        nextBtn.classList.toggle('is-disabled', splide.index >= endIndex)
      }
    }

    splide.on('mounted move', updateArrows)

    if (!isMarquee) {
      splide.on('pagination:mounted', function (data) {
        data.items.forEach(function (item, index) {
          const number = index + 1
          const progress = document.createElement('span')

          item.button.textContent = number < 10 ? '0' + number : number
          progress.classList.add('progress-bar')
          item.button.appendChild(progress)
        })
      })

      function startProgress() {
        clearInterval(progressInterval)

        element.querySelectorAll('.progress-bar').forEach(bar => {
          bar.style.width = '0%'
        })

        setTimeout(() => {
          const activeBar = element.querySelector('.splide__pagination__page.is-active .progress-bar')

          if (!activeBar) return

          const duration = splide.options.interval
          const startTime = Date.now()

          progressInterval = setInterval(() => {
            const elapsed = Date.now() - startTime
            let progress = (elapsed / duration) * 100

            if (progress >= 100) {
              progress = 100
              clearInterval(progressInterval)
            }

            activeBar.style.width = progress + '%'
          }, 40)
        }, 10)
      }

      splide.on('mounted moved', function () {
        if (splide.options.autoplay) {
          startProgress()
        }
      })

      splide.on('drag', () => {
        clearInterval(progressInterval)
      })
    }

    sliderInstances.set(element, {
      splide: splide,
      destroy: function () {
        clearInterval(progressInterval)
        if (prevBtn) prevBtn.removeEventListener('click', goPrev)
        if (nextBtn) nextBtn.removeEventListener('click', goNext)
        splide.destroy(true)
      },
    })

    if (isMarquee && window.splide && window.splide.Extensions) {
      splide.mount(window.splide.Extensions)
    } else {
      splide.mount()
    }
  }

  function destroySplide(element) {
    const instance = sliderInstances.get(element)

    if (!instance) return

    instance.destroy()
    sliderInstances.delete(element)
  }

  function initSplideSliders(context) {
    const scope = context || document

    if (scope.matches && scope.matches('splide-slider')) {
      scope.init()
    }

    scope.querySelectorAll('splide-slider').forEach(component => {
      component.init()
    })

    scope.querySelectorAll('.splide').forEach(element => {
      if (element.closest('splide-slider')) return
      mountSplide(element)
    })
  }

  class SplideSlider extends HTMLElement {
    connectedCallback() {
      this.init()
    }

    disconnectedCallback() {
      const element = this.querySelector('.splide')
      destroySplide(element)
    }

    init() {
      mountSplide(this.querySelector('.splide'))
    }
  }

  if (!customElements.get('splide-slider')) {
    customElements.define('splide-slider', SplideSlider)
  }

  window.SplideSliderFunction = initSplideSliders

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSplideSliders(document))
  } else {
    initSplideSliders(document)
  }

  document.addEventListener('shopify:section:load', event => {
    initSplideSliders(event.target)
  })
})()

class VideoLazy extends HTMLElement {
  constructor() {
    super()

    this.button = this.querySelector('button')
    this.template = this.querySelector('template')
    this.videoWrapper = this.querySelector('.video-wrapper')
    this.posterImage = this.querySelector('img') // Grab the poster image

    if (this.button) {
      this.button.addEventListener('click', () => {
        if (this.template && this.videoWrapper) {
          // 1. Clear wrapper and inject the video clone
          this.videoWrapper.innerHTML = ''
          const videoContent = this.template.content.cloneNode(true)
          this.videoWrapper.appendChild(videoContent)

          // 2. Remove the button and poster image from the DOM
          if (this.button) this.button.remove()
          if (this.posterImage) this.posterImage.remove()
        }
      })
    }
  }
}

customElements.define('video-lazy', VideoLazy)

class FaqAccordion extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.faq-accordion-item')

    this.items.forEach(item => {
      const summaryBtn = item.querySelector('.faq-accordion-summary')

      if (summaryBtn) {
        summaryBtn.addEventListener('click', () => this.toggleItem(item))
      }
    })

    // Open first item by default
    if (this.items.length > 0) {
      this.toggleItem(this.items[0])
    }
  }

  toggleItem(clickedItem) {
    const bodyPanel = clickedItem.querySelector('.faq-accordion-body')
    const isAlreadyOpen = clickedItem.classList.contains('is-open')

    // Reset all
    this.items.forEach(item => {
      const panel = item.querySelector('.faq-accordion-body')

      item.classList.remove('is-open', 'above-open')

      if (panel) {
        panel.style.height = '0px'
      }
    })

    // Open clicked item
    if (!isAlreadyOpen && bodyPanel) {
      clickedItem.classList.add('is-open')

      // Add class to previous/top item
      const prevItem = clickedItem.previousElementSibling

      if (prevItem?.classList.contains('faq-accordion-item')) {
        prevItem.classList.add('above-open')
      }

      bodyPanel.style.height = `${bodyPanel.scrollHeight}px`
    }
  }
}

customElements.define('faq-accordion', FaqAccordion)

// Define the component if it hasn't been declared yet
if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion)
}
